import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd-v5';
import PropTypes from 'prop-types';
import StoresFilter from './components/StoresFilter';

const StoresFilterModal = ({ open, onClose, stores, includedStoreIds, onApply }) => {
  const [localIds, setLocalIds] = useState([]);

  useEffect(() => {
    if (open) {
      setLocalIds(includedStoreIds || []);
    }
  }, [open, includedStoreIds]);

  const handleApply = () => {
    onApply(localIds);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Stores"
      footer={null}
      className="audience-filter-modal"
      width={480}
      centered
    >
      <div style={{ padding: '8px 0 16px' }}>
        <StoresFilter stores={stores} includedStoreIds={localIds} onChange={setLocalIds} />
      </div>
      <div className="audience-filter-modal__footer">
        <Button
          type="link"
          onClick={() => setLocalIds([])}
          disabled={localIds.length === 0}
        >
          Clear
        </Button>
        <div className="audience-filter-modal__footer-right">
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </div>
    </Modal>
  );
};

StoresFilterModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  stores: PropTypes.array,
  includedStoreIds: PropTypes.array,
  onApply: PropTypes.func.isRequired,
};

StoresFilterModal.defaultProps = {
  stores: [],
  includedStoreIds: [],
};

export default StoresFilterModal;
